import React, { useRef, useState } from 'react'
import { Order } from '../../../Models/Order'
import GGLoaderButton from '../../CommonComponents/GGLoaderButton/GGLoaderButton';
import { StarsRounded } from '@mui/icons-material';
import { Box, TextField, Typography } from '@mui/material';
import StarRating from '../../CommonComponents/StarRating/StarRating';
import SnackBar, { SnackTypes } from '../../UtilityComponents/SnackBar/SnackBar';
import { Review } from '../../../Models/Review';
import { ReviewAPIHandler } from '../../../services/NetworkClient/BackendAPIs/ReviewAPIHandler';

interface OrderDetailsPageRatingsProps {
    order: Order;
    onSubmitCompletion: () => void
}

const OrderDetailsPageRatingsSection = ({ order, onSubmitCompletion }: OrderDetailsPageRatingsProps) => {

    // Snackbar based status handling 
    const snackBarRef = useRef<{ showSnackbar(): any }>(null)
    const [snackBarParams, setSnackBarParams] = useState({
        message: "",
        state: SnackTypes.error,
    });

    const showSnackbar = (message: string, state: SnackTypes) => {
        setSnackBarParams({ message: message, state: state });
        snackBarRef.current?.showSnackbar();
    };

    const RatingsForm = () => {

        const [reviewComments, setReviewComments] = useState("");
        const [rating, setRating] = useState(0);
        const [loading, setLoading] = useState(false)

        const handleRatingReviewSubmit = async () => {
            if (rating === 0) {
                showSnackbar("Please provide a rating!", SnackTypes.error);
                return;
            }
            if (reviewComments.trim() === "") {
                showSnackbar("Please provide a review!", SnackTypes.error);
                return;
            }

            const reviewData = {
                gigId: order.metaData.gig.id, 
                order: order.id,
                rating: rating,
                attachments: [],
                comment: reviewComments
            }

            setLoading(true)
            ReviewAPIHandler.shared.createReview(reviewData)
              .then(() => {
                showSnackbar("Review submitted successfully!", SnackTypes.success);
                setLoading(false)
                onSubmitCompletion()
              })    
              .catch((error) => {
                setLoading(false)
                showSnackbar(
                  (error as string) || "Failed to submit review!",
                  SnackTypes.error
                );
              });
        };


        return (
            <section className="rating-and-review">
                <div className="rating-and-review-header">
                    <StarsRounded />
                    <h2>Rating and Review</h2>
                </div>
                <div className="rating-and-review-content">
                    {/* heading saying how was your experience with <Freelancer Name> ? */}
                    <Typography variant="h6" className="rating-and-review-text">
                        How was your experience with {" "}
                        <b>{order?.metaData.seller.fullName}</b> ?
                    </Typography>

                    <StarRating
                        className="star-rating-row"
                        value={rating}
                        onChange={setRating}
                    />
                   
                    <TextField
                        style={{ width: "70%" }}
                        value={reviewComments}
                        onChange={(e) => setReviewComments(e.target.value)}
                        className="feedback-textarea"
                        id="outlined-multiline-static"
                        multiline
                        fullWidth
                        rows={2.5}
                        placeholder="How did you like this service...?"
                    />

                    <GGLoaderButton
                        className="submit-review-btn"
                        variant="outlined"
                        style={{ width: "fit-content", border: "none" }}
                        isLoading={loading}
                        onClick={handleRatingReviewSubmit}
                    >
                        Submit Review
                    </GGLoaderButton>
                </div>
            </section>
        )
    }

    const StaticRatings = ({review}: {review: Review}) => {
        return (
            <section className="rating-and-review">
                <div className="rating-and-review-header">
                    <StarsRounded />
                    <h2>Rating and Review</h2>
                </div>
                <Box className="rating-and-review-content">
                    {/* heading saying how was your experience with <Freelancer Name> ? */}
                    <Typography variant="h6" className="rating-and-review-text">
                        You hava rated {" "}
                        <b>{order?.metaData.seller.fullName}</b>!
                    </Typography>

                    <StarRating
                        className="star-rating-row"
                        disabled={true}
                        value={review.rating}
                    />

                     <Box flexDirection={"column"} display={"flex"} padding={"20px"} width={"95%"} sx={{border: "1px solid rgb(215, 215, 215)"}}>
                        <Typography fontSize={"16px"} fontWeight={1000} marginBottom={"10px"}> 
                            Comments -
                        </Typography>

                        <Typography fontSize={"24px"}> 
                            {review.comment}
                        </Typography>
                    </Box>
                    
                </Box>
            </section>
        )
    }

    return (
        <div>
             <SnackBar
                ref={snackBarRef}
                severity={snackBarParams.state}
                alertDuration={5000}
                message={snackBarParams.message}
            />

            {order.review ? <StaticRatings review={order.review}/> : <RatingsForm />}

        </div>
    )
}

export default OrderDetailsPageRatingsSection